import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import CatalogueBanner from '../components/CatalogueBanner';
import './CataloguePage.css';
import Footer from '../components/Footer';
import useSEO from '../hooks/useSEO';

const CataloguePage = () => {
    useSEO({
        title: "Product Catalogue | Prime Rehab Industries Physiotherapy Equipment",
        description: "Browse the full Prime Rehab Industries product catalogue of physiotherapy, chiropractic and rehabilitation equipment manufactured in Chennai, India.",
        canonical: "https://www.primerehabindustries.in/catalogue"
    });
    // Scroll to top when the page loads
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="catalogue-page">
            <Navbar />

            <main className="catalogue-page-content">
                <CatalogueBanner />
                
            </main>
            <Footer/>
        </div>
    );
};

export default CataloguePage;
